<h2 i18n="@@titleGroups">Groups</h2>

@if (loaded()) {
	@if (treeNodes().length > 0) {
		<div class="tree-card">
			@for (node of treeNodes(); track trackNode($index, node)) {

				@if (node.kind === 'group') {
					@let g = asGroup(node);
					<div class="tree-row" [style.padding-left.px]="g.level * 20 + 8">

						<div class="expand-cell">
							@if (g.loading) {
								<mat-spinner diameter="20" />
							} @else if (hasKnownChildren(g)) {
								<button mat-icon-button (click)="toggleExpand(g)">
									<mat-icon>{{ g.expanded ? 'expand_more' : 'chevron_right' }}</mat-icon>
								</button>
							}
						</div>

						<mat-icon class="folder-icon">{{ g.expanded ? 'folder_open' : (g.groupId === UNGROUPED_ID ? 'folder_special' : 'folder') }}</mat-icon>

						<span class="group-name">{{ g.name }}</span>

						<span class="tree-spacer"></span>

						@if (g.groupId !== UNGROUPED_ID) {
							<button 
								mat-icon-button 
								[matMenuTriggerFor]="menu" 
								#menuTrigger="matMenuTrigger"
								(click)="$event.stopPropagation()"
							>
								<mat-icon>more_vert</mat-icon>
							</button>
							<mat-menu #menu="matMenu">
								<button mat-menu-item (click)="menuTrigger.closeMenu(); openCreateDialog($event, g)">
									<mat-icon>create_new_folder</mat-icon>
									<span i18n="@@AddSubgroup">Add Subgroup</span>
								</button>
								<button mat-menu-item (click)="menuTrigger.closeMenu(); openAssignChargerDialog($event, g)">
									<mat-icon>add_circle</mat-icon>
									<span i18n="@@AddCharger">Add Charger</span>
								</button>
								<button mat-menu-item (click)="menuTrigger.closeMenu(); openEditDialog($event, g)">
									<mat-icon>edit</mat-icon>
									<span i18n="@@Edit">Edit</span>
								</button>
								<button mat-menu-item (click)="menuTrigger.closeMenu(); openDeleteDialog($event, g)">
									<mat-icon color="warn">delete</mat-icon>
									<span i18n="@@Delete">Delete</span>
								</button>
							</mat-menu>
						}
					</div>

				} @else if (node.kind === 'sentinel') {
					<div class="ungrouped-sentinel" [style.padding-left.px]="node.level * 20 + 8 + 36 + 24">
						@if (ungroupedLoadingMore()) {
							<mat-spinner diameter="20" />
						}
					</div>

				} @else {
					@let c = asCharger(node);
					<div class="tree-row charger-row"
						[style.padding-left.px]="(node.level - 1) * 20 + 8 + 36 + 24"
						[routerLink]="['/charger', node.chargerId]"
					>
						<span class="charger-status-icon">{{ c.cloudConnectionState !== 'Online' ? '🟠' :
							c.chargingState === 'Charging' ? '🟢' :
							c.chargingState === 'Error' ? '🔴' : '🔵' }}</span>
						<span class="charger-info">
							<span class="charger-name">{{ node.chargerId }}</span>
							<span class="charger-state">{{ c.cloudConnectionState === 'Online' ? (c.chargingState | chargingStateTranslate) : ('Offline' | chargingStateTranslate) }}</span>
						</span>
						<span class="tree-spacer"></span>
						<button
							mat-icon-button
							[matMenuTriggerFor]="chargerMenu"
							#chargerMenuTrigger="matMenuTrigger"
							(click)="$event.stopPropagation()"
						>
							<mat-icon>more_vert</mat-icon>
						</button>
						<mat-menu #chargerMenu="matMenu">
							<button mat-menu-item (click)="chargerMenuTrigger.closeMenu(); openMoveChargerDialog($event, c)">
								<mat-icon>drive_file_move</mat-icon>
								<span i18n="@@MoveCharger">Move Charger</span>
							</button>
							<button mat-menu-item (click)="chargerMenuTrigger.closeMenu(); openDeleteChargerDialog($event, c)">
								<mat-icon color="warn">delete</mat-icon>
								<span i18n="@@DeleteCharger">Delete Charger</span>
							</button>
						</mat-menu>
					</div>
				}

			}
		</div>
	} @else {
		<span i18n="@@NoGroupsAvailable">No groups available.</span><br/><br/>
	}

	<button matButton="elevated" color="primary"
		(click)="isInstaller && openCreateDialog($event)"
		[disabled]="!isInstaller"
		i18n-matTooltip
		matTooltip="Only installers can add groups"
		[matTooltipDisabled]="isInstaller"
		[disabledInteractive]="true"
	>
		<mat-icon>add</mat-icon>
		<span i18n="@@AddGroup">Add Group</span>
	</button>
} @else {
	<mat-spinner />
}
